export function arrayIncludes(arr = [], search = "") {
  let s = search.toLowerCase();
  return arr.some((v) => (v || "").toLowerCase() === s)
}